import { MobileSearchFieldShell } from "./mobile-search-frame";
import {
  MobileSearchClearButton,
  MobileSearchSubmitButton,
} from "./mobile-search-overlay-controls";

const getFieldShellClassName = ({ isMainOverlay, isPlayOverlay }) =>
  `relative flex items-center gap-2 ${
    isMainOverlay
      ? "pl-4 pr-0"
      : `min-w-0 flex-1 rounded-full border border-black/5 bg-white shadow-sm dark:bg-white/10 ${
          isPlayOverlay ? "h-[42px] pl-4 pr-0" : "h-12 px-4"
        }`
  }`;

const MobileSearchOverlayField = ({
  search,
  setSearch,
  inputRef,
  isMainOverlay,
  isPlayOverlay,
  hasEmbeddedSearchActions,
  onClearOrClose,
}) => (
  <MobileSearchFieldShell
    useBase={isMainOverlay}
    className={getFieldShellClassName({ isMainOverlay, isPlayOverlay })}
  >
    <input
      ref={inputRef}
      value={search}
      onChange={(event) => setSearch(event.target.value)}
      placeholder="검색"
      className={`min-w-0 flex-1 bg-transparent font-medium leading-5 outline-none placeholder:text-black/40 dark:placeholder:text-white/40 ${
        hasEmbeddedSearchActions ? "text-[16px]" : "text-[17px]"
      } ${isMainOverlay ? "pr-[88px]" : ""}`}
    />
    <MobileSearchSubmitButton
      isMainOverlay={isMainOverlay}
      isPlayOverlay={isPlayOverlay}
      hasEmbeddedSearchActions={hasEmbeddedSearchActions}
    />
    {hasEmbeddedSearchActions && (
      <MobileSearchClearButton
        isMainOverlay={isMainOverlay}
        isPlayOverlay={isPlayOverlay}
        embedded
        ariaLabel={search ? "검색어 지우기" : "검색 닫기"}
        onClick={onClearOrClose}
      />
    )}
  </MobileSearchFieldShell>
);

export default MobileSearchOverlayField;
